import { createContext, useContext, useState, useMemo, useCallback } from "react";
import translations from "@/translations.json";

const LanguageContext = createContext();

const LANGUAGES = ["en", "fr", "de"];

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");

  const cycleLang = useCallback(() => {
    setLang((current) => LANGUAGES[(LANGUAGES.indexOf(current) + 1) % LANGUAGES.length]);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const selectLang = useCallback((newLang) => {
    setLang(newLang);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const contextValue = useMemo(() => ({
    lang,
    cycleLang,
    selectLang,
    t: translations[lang]
  }), [lang, cycleLang, selectLang]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
